import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { map, take } from 'rxjs';

export const adminGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.user$.pipe(
    take(1),
    map((user) => {
      const roles = (user?.['https://efactorypro.com/roles'] as string[]) ?? [];

      return roles.includes('Admin') ? true : router.createUrlTree(['/site-configuration/summary']);
    })
  );
};
